import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import Layout from '@/components/feature/Layout';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <RankingSection />
      <CategoryGrid />
      <ArticleSection />
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
              开启你的韩漫之旅
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-6">
              加入韩漫星球，发现更多优质韩国漫画。从恋爱到热血，从悬疑到奇幻，总有一部作品适合你。
            </p>
            <a
              href="/category/lianai"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-50/90 transition-all whitespace-nowrap cursor-pointer"
            >
              立即探索
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>
      <FAQSection />
    </Layout>
  );
}